import React, { useEffect, useCallback, useState} from 'react';
import ModulatorControls from "components/modulators/ModulatorControls.js";
import {connect} from 'react-redux';
import LFOToggle from './LFOToggle.js';

const Modulators = ({sequencerEngine, parameter, connectToLFO, disconnectFromLFO}) => { 
    const getLFOs = useCallback(() => {
        if (sequencerEngine !== undefined) {
            let track = parameter.track ||
                parameter.context.track;
            if (track && track.subSequence) {
                let subSequence = track.subSequence;
                return subSequence.lfosTrack.lfos.map(lfo => lfo.lfo);
            } else {
                if (parameter.context.subSequence) {
                    return parameter.context.subSequence.lfosTrack.lfos.map(lfo => lfo.lfo);
                }
                return sequencerEngine.lfosTrack.lfos.map(lfo => lfo.lfo);
            }
        }
        return [];
    }, [parameter]);

    let [lfos, setLfos] = useState(getLFOs());
    useEffect(() => {
        setLfos(getLFOs());
    }, [parameter, setLfos]);
    return (
        <div className="modulators-container">
          <div className="lfo-boxes">{
              lfos && lfos.map(
                  (lfo, i) =>
                      <LFOToggle 
                        connectToLFO={connectToLFO}
                        disconnectFromLFO={disconnectFromLFO}
                        key={i}
                        isToggled={true}
                        parameter={parameter}
                        lfo={lfo}
                        lfos={lfos}
                        parameter={parameter}
                      ></LFOToggle>)}
            </div>
          <ModulatorControls sequencerEngine={sequencerEngine} parameter={parameter}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modulators);
